module.exports = __webpack_public_path__ + "static/img/card_bg@2x.190cd24.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/greenchannel/card_bg@2x.png
// module id = WAi6
// module chunks = 1